$(document).ready(function() {
    $('.user-logout').click(function () {
        event.preventDefault();

        $(".profile-menu").removeClass("active");
        $(".logout_bg").show();
        $(".logout_popup").addClass("active");
        $('html').css('overflow', 'hidden');  //ADD THIS

        $.ajax({
            type: "POST",
            url: "/requests/user.php?domain_id=" + window.domain_id,
            data: {
                action: 'logout'
            },
            success: function () {
                if (window.location.href.indexOf(profileUrl) == -1) {
                    window.location.reload();
                } else {
                    window.location.replace(routePrefix + '/');
                }
            }
        });
    });

    $("#deleteAccount").ajaxForm({
        success: function(result) {
            window.location.replace(routePrefix + "/");
        },
        error: function(err) {
            $(".formErrors li").remove();
            $(".formErrors").css('display', 'block');

            if (err.status == 403) {
                var errorTranslation = translations['error.unauthorized'];
            } else if (err.status == 405) {
                var errorTranslation = translations['error.empty'];
            } else {
                var errorTranslation = translations['error.notFound']; 
            }

            $(".formErrors")
                .append('<li>' + errorTranslation + '</li>');
        }
    });
});